import Api2Talk from "../../services/api2talk";
import { formatRegisteredNumberLabel } from "../../utils/registrationNumberLabel";

 export const getPhoneNumberList = async () => {
	let data;
	await Api2Talk.get("/registrationphonenumber/getallphoneactiveable")
		.then(result => {
			//console.error('RESULTT0');
			//console.error(result);
			if (result.data.success) {

				var formatlist = result.data.data.map(item => {
					return {
						id: item.id,
						name: formatRegisteredNumberLabel(item),
						phonenumber: item.phonenumber,
						accountname: item.accountname,
						accountid: item.accountid,
						messageproviderid: item.messageproviderid
					}
				})
				result.data.data=formatlist;
				data= result.data;

			} else {
				data= result.data;
			}
		})
		.catch(err => {
			data=err;
		 
		});
	return data;
}


export const getPhoneNumberListFromChannel = async (id) => {
	let data;
	await Api2Talk.get(`/registrationphonenumber/channel/${id}`)
		.then(result => {
			if (result.data.success) {

				
				var formatlist = result.data.data.map(item => {
					return {
						id: item.id,
						name: item.phonenumber,
						phonenumber: item.phonenumber,
						accountid : item.accountid, 
						channelid: item.channelid, 
						companyaccountid: item.companyaccountid,
						companyname: item.companyname,
						messageproviderconfigid: item.messageproviderconfigid,
						messageproviderid: item.messageproviderid,
						organizationid: item.organizationid,
						phonenumberid: item.phonenumberid,
						requeststatusid: item.requeststatusid,
						techinicalteamid: item.channel?.techinicalteamid,
						originrequestid: item.messageprovider?.originrequest?.id
					}
				})
				result.data.data=formatlist;
				
				data= result.data;

			} else {
				data= result.data;
			}
		})
		.catch(err => {
			data=err;
		 
		});
	return data;
}

export const organizationHasRegistrationNumberRequestActive = async (id) => {
	let data;
	await Api2Talk.get(`/registrationphonenumber/by-organization/${id}`)
		.then(result => {
			if (result.data.success) {
				data= result.data;
			} else {
				data= result.data;
			}
		})
		.catch(err => {
			data=err;
		 
		});
	return data;
}


export const metaRquest = async (formData) => { 
	let data = []
	await Api2Talk.post(`/registrationphonenumber/meta-request`, formData)
	  .then(result => {
		data = result.data
	  })
	  .catch(err => {
		data = err.response
	  })
	return data
  }


export const metaDataVerification = async (formData) => {
	let data = []
	await Api2Talk.post(`/registrationphonenumber/meta-data-verification`, formData)
	  .then(result => {
		data = result.data
	  })
	  .catch(err => {
		data = err.response
	  })
	return data
  }

  export const getMetaSignupConfig = async () => {
	let data = []
	await Api2Talk.get(`/registrationphonenumber/meta-signup/config`)
	  .then(result => {
		data = result.data
	  })
	  .catch(err => {
		data = err.response
	  })
	return data
  }

  export const metaSignupSession = async (formData) => {
	let data = []
	await Api2Talk.post(`/registrationphonenumber/meta-signup/session`, formData)
	  .then(result => {
		data = result.data
	  })
	  .catch(err => {
		data = err.response
	  })
	return data
  }

  export const verifyPhoneExists = async (phoneNumber) => {
	let data;
	await Api2Talk.get(`/registrationphonenumber/verify-phone-exists?phoneNumber=${phoneNumber}`)
	  .then(result => {
		data = result.data
	  })
	  .catch(err => {
		data = err.response?.data || err
	  })
	return data
  }
